// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"102":"b1d28666","453":"81c30559","593":"46b62604","629":"be3000d1"}[chunkId] + ".chunk.js";
};